import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseRestockStatusProviderService } from '../providers/warehouse-restock-status-provider.service';
import { WarehouseRestockStatus } from '../enums/warehouse-restock-status';

@Pipe({
  name: 'warehouseRestockStatus',
  standalone: true,
})
export class WarehouseRestockStatusPipe implements PipeTransform {
  private readonly provider = inject(WarehouseRestockStatusProviderService);

  public transform(status: WarehouseRestockStatus): Observable<string> {
    return this.provider.label(status);
  }
}
